import "core-js/modules/es6.array.map";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.trim";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.array.is-array";
export var Filters;

(function (Filters) {
  var valueSeparator = ',';
  var defaultValue = '';

  var getParamValueForSystemFilter = function getParamValueForSystemFilter(param) {
    if (!param) {
      return defaultValue;
    }

    if (Array.isArray(param)) {
      var value = ''; // use [in] filter

      for (var i = 0; i < param.length; i++) {
        value = value + param[i].toString();

        if (i !== param.length - 1) {
          // append separator if its not last item
          value = value + valueSeparator;
        }
      }

      return value;
    } // single param was given


    return param.toString();
  };

  var TypeFilter =
  /*#__PURE__*/
  function () {
    function TypeFilter(type) {
      _classCallCheck(this, TypeFilter);

      this.type = type;
    }

    _createClass(TypeFilter, [{
      key: "getParam",
      value: function getParam() {
        if (Array.isArray(this.type)) {
          // multiple types
          return "system.type[in]=".concat(getParamValueForSystemFilter(this.type));
        } // single type


        return "system.type=".concat(getParamValueForSystemFilter(this.type));
      }
    }]);

    return TypeFilter;
  }();

  Filters.TypeFilter = TypeFilter;

  var CollectionFilter =
  /*#__PURE__*/
  function () {
    function CollectionFilter(collection) {
      _classCallCheck(this, CollectionFilter);

      this.collection = collection;
    }

    _createClass(CollectionFilter, [{
      key: "getParam",
      value: function getParam() {
        if (Array.isArray(this.collection)) {
          // multiple collections
          return "system.collection[in]=".concat(getParamValueForSystemFilter(this.collection));
        } // single collection


        return "system.collection=".concat(getParamValueForSystemFilter(this.collection));
      }
    }]);

    return CollectionFilter;
  }();

  Filters.CollectionFilter = CollectionFilter;

  var EmptyFilter =
  /*#__PURE__*/
  function () {
    function EmptyFilter(element) {
      _classCallCheck(this, EmptyFilter);

      this.element = element;
    }

    _createClass(EmptyFilter, [{
      key: "getParam",
      value: function getParam() {
        return "".concat(this.element.trim(), "[empty]");
      }
    }]);

    return EmptyFilter;
  }();

  Filters.EmptyFilter = EmptyFilter;

  var NotEmptyFilter =
  /*#__PURE__*/
  function () {
    function NotEmptyFilter(element) {
      _classCallCheck(this, NotEmptyFilter);

      this.element = element;
    }

    _createClass(NotEmptyFilter, [{
      key: "getParam",
      value: function getParam() {
        return "".concat(this.element.trim(), "[nempty]");
      }
    }]);

    return NotEmptyFilter;
  }();

  Filters.NotEmptyFilter = NotEmptyFilter;

  var EqualsFilter =
  /*#__PURE__*/
  function () {
    function EqualsFilter(element, value) {
      _classCallCheck(this, EqualsFilter);

      this.element = element;
      this.value = value;
    }

    _createClass(EqualsFilter, [{
      key: "getParam",
      value: function getParam() {
        return "".concat(this.element.trim(), "[eq]=").concat(this.getParamValue());
      }
    }, {
      key: "getParamValue",
      value: function getParamValue() {
        if (!this.value) {
          return defaultValue;
        }

        return this.value;
      }
    }]);

    return EqualsFilter;
  }();

  Filters.EqualsFilter = EqualsFilter;

  var NotEqualsFilter =
  /*#__PURE__*/
  function () {
    function NotEqualsFilter(element, value) {
      _classCallCheck(this, NotEqualsFilter);

      this.element = element;
      this.value = value;
    }

    _createClass(NotEqualsFilter, [{
      key: "getParam",
      value: function getParam() {
        return "".concat(this.element.trim(), "[neq]=").concat(this.getParamValue());
      }
    }, {
      key: "getParamValue",
      value: function getParamValue() {
        if (!this.value) {
          return defaultValue;
        }

        return this.value;
      }
    }]);

    return NotEqualsFilter;
  }();

  Filters.NotEqualsFilter = NotEqualsFilter;

  var AllFilter =
  /*#__PURE__*/
  function () {
    function AllFilter(element, values) {
      _classCallCheck(this, AllFilter);

      this.element = element;
      this.values = values;
    }

    _createClass(AllFilter, [{
      key: "getParam",
      value: function getParam() {
        return "".concat(this.element.trim(), "[all]=").concat(this.getParamValue());
      }
    }, {
      key: "getParamValue",
      value: function getParamValue() {
        if (!this.values || !Array.isArray(this.values)) {
          return defaultValue;
        }

        return this.values.map(function (m) {
          return m.trim();
        }).join(',');
      }
    }]);

    return AllFilter;
  }();

  Filters.AllFilter = AllFilter;

  var AnyFilter =
  /*#__PURE__*/
  function () {
    function AnyFilter(element, values) {
      _classCallCheck(this, AnyFilter);

      this.element = element;
      this.values = values;
    }

    _createClass(AnyFilter, [{
      key: "getParam",
      value: function getParam() {
        return "".concat(this.element.trim(), "[any]=").concat(this.getParamValue());
      }
    }, {
      key: "getParamValue",
      value: function getParamValue() {
        if (!this.values || !Array.isArray(this.values)) {
          return defaultValue;
        }

        return this.values.map(function (m) {
          return m.trim();
        }).join(',');
      }
    }]);

    return AnyFilter;
  }();

  Filters.AnyFilter = AnyFilter;

  var ContainsFilter =
  /*#__PURE__*/
  function () {
    function ContainsFilter(element, values) {
      _classCallCheck(this, ContainsFilter);

      this.element = element;
      this.values = values;
    }

    _createClass(ContainsFilter, [{
      key: "getParam",
      value: function getParam() {
        return "".concat(this.element.trim(), "[contains]=").concat(this.getParamValue());
      }
    }, {
      key: "getParamValue",
      value: function getParamValue() {
        if (!this.values || !Array.isArray(this.values)) {
          return defaultValue;
        }

        return this.values.map(function (m) {
          return m.trim();
        }).join(',');
      }
    }]);

    return ContainsFilter;
  }();

  Filters.ContainsFilter = ContainsFilter;

  var GreaterThanFilter =
  /*#__PURE__*/
  function () {
    function GreaterThanFilter(element, value) {
      _classCallCheck(this, GreaterThanFilter);

      this.element = element;
      this.value = value;
    }

    _createClass(GreaterThanFilter, [{
      key: "getParam",
      value: function getParam() {
        return "".concat(this.element.trim(), "[gt]=").concat(this.getParamValue());
      }
    }, {
      key: "getParamValue",
      value: function getParamValue() {
        if (!this.value) {
          return defaultValue;
        }

        return this.value;
      }
    }]);

    return GreaterThanFilter;
  }();

  Filters.GreaterThanFilter = GreaterThanFilter;

  var GreaterThanOrEqualFilter =
  /*#__PURE__*/
  function () {
    function GreaterThanOrEqualFilter(element, value) {
      _classCallCheck(this, GreaterThanOrEqualFilter);

      this.element = element;
      this.value = value;
    }

    _createClass(GreaterThanOrEqualFilter, [{
      key: "getParam",
      value: function getParam() {
        return "".concat(this.element.trim(), "[gte]=").concat(this.getParamValue());
      }
    }, {
      key: "getParamValue",
      value: function getParamValue() {
        if (!this.value) {
          return defaultValue;
        }

        return this.value;
      }
    }]);

    return GreaterThanOrEqualFilter;
  }();

  Filters.GreaterThanOrEqualFilter = GreaterThanOrEqualFilter;

  var InFilter =
  /*#__PURE__*/
  function () {
    function InFilter(element, values) {
      _classCallCheck(this, InFilter);

      this.element = element;
      this.values = values;
    }

    _createClass(InFilter, [{
      key: "getParam",
      value: function getParam() {
        return "".concat(this.element.trim(), "[in]=").concat(this.getParamValue());
      }
    }, {
      key: "getParamValue",
      value: function getParamValue() {
        if (!this.values || !Array.isArray(this.values)) {
          return defaultValue;
        }

        return this.values.map(function (m) {
          return m.trim();
        }).join(',');
      }
    }]);

    return InFilter;
  }();

  Filters.InFilter = InFilter;

  var NotInFilter =
  /*#__PURE__*/
  function () {
    function NotInFilter(element, values) {
      _classCallCheck(this, NotInFilter);

      this.element = element;
      this.values = values;
    }

    _createClass(NotInFilter, [{
      key: "getParam",
      value: function getParam() {
        return "".concat(this.element.trim(), "[nin]=").concat(this.getParamValue());
      }
    }, {
      key: "getParamValue",
      value: function getParamValue() {
        if (!this.values || !Array.isArray(this.values)) {
          return defaultValue;
        }

        return this.values.map(function (m) {
          return m.trim();
        }).join(',');
      }
    }]);

    return NotInFilter;
  }();

  Filters.NotInFilter = NotInFilter;

  var LessThanFilter =
  /*#__PURE__*/
  function () {
    function LessThanFilter(element, value) {
      _classCallCheck(this, LessThanFilter);

      this.element = element;
      this.value = value;
    }

    _createClass(LessThanFilter, [{
      key: "getParam",
      value: function getParam() {
        return "".concat(this.element.trim(), "[lt]=").concat(this.getParamValue());
      }
    }, {
      key: "getParamValue",
      value: function getParamValue() {
        if (!this.value) {
          return defaultValue;
        }

        return this.value;
      }
    }]);

    return LessThanFilter;
  }();

  Filters.LessThanFilter = LessThanFilter;

  var LessThanOrEqualFilter =
  /*#__PURE__*/
  function () {
    function LessThanOrEqualFilter(element, value) {
      _classCallCheck(this, LessThanOrEqualFilter);

      this.element = element;
      this.value = value;
    }

    _createClass(LessThanOrEqualFilter, [{
      key: "getParam",
      value: function getParam() {
        return "".concat(this.element.trim(), "[lte]=").concat(this.getParamValue());
      }
    }, {
      key: "getParamValue",
      value: function getParamValue() {
        if (!this.value) {
          return defaultValue;
        }

        return this.value;
      }
    }]);

    return LessThanOrEqualFilter;
  }();

  Filters.LessThanOrEqualFilter = LessThanOrEqualFilter;

  var RangeFilter =
  /*#__PURE__*/
  function () {
    function RangeFilter(element, lowerValue, higherValue) {
      _classCallCheck(this, RangeFilter);

      this.element = element;
      this.lowerValue = lowerValue;
      this.higherValue = higherValue;
    }

    _createClass(RangeFilter, [{
      key: "getParam",
      value: function getParam() {
        return "".concat(this.element.trim(), "[range]=").concat(this.getParamValue());
      }
    }, {
      key: "getParamValue",
      value: function getParamValue() {
        var lowerVal = defaultValue;
        var higherVal = defaultValue;

        if (this.lowerValue) {
          lowerVal = this.lowerValue.toString();
        }

        if (this.higherValue) {
          higherVal = this.higherValue.toString();
        }

        return "".concat(lowerVal, ",").concat(higherVal);
      }
    }]);

    return RangeFilter;
  }();

  Filters.RangeFilter = RangeFilter;
})(Filters || (Filters = {}));